import React, { useEffect, useState } from "react";

const HReviewScreen = ({ onBackClick, url }) => {
    const [iframeHeight, setIframeHeight] = useState(800);

    useEffect(() => {
        const updateHeight = () => {
            const iframe = document.getElementById('iframe-h-review');
            const yPos = iframe.getBoundingClientRect().top;
            setIframeHeight(window.innerHeight - yPos);
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div style={{ position: "absolute", zIndex: "10000", width: "100%" }}>
            <div className="iframe-container" style={{ position: "relative", padding: "0 16px" }}>
                <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "16px" }}>
                    <button className="bn bn-small bg-sky-blue-gradient" onClick={onBackClick}>
                        BACK
                    </button>
                </div>
                <iframe
                    id="iframe-h-review"
                    src={url}
                    width="100%"
                    height={`${iframeHeight}px`}
                    title="Hawk-I Review Screen"
                    style={{ border: "none" }}
                />
            </div>
        </div>
    );
};

export default HReviewScreen;